import styled from 'styled-components';
import { Autocomplete, Option } from '@carvana/showroom-autocomplete';

export const StyledOption = styled(Option)`
  font-weight: 700;
  padding-left: 40px;

  mark {
    font-weight: 400;
  }
`;

export const StyledAutocomplete = styled(Autocomplete)`
  > div[role='listbox'] {
    &::-webkit-scrollbar {
      width: 6px;
      background-color: ${(props) => props.theme.carvana.gray.light};
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 8px;
      background-color: ${(props) => props.theme.carvana.blue.dark};
    }

    &::-webkit-scrollbar-track {
      border-radius: 8px;
      background-color: ${(props) => props.theme.carvana.gray.light};
    }
  }
`;
